import script from "./pc-recommend-task.vue?vue&type=script&setup=true&lang=js"
export * from "./pc-recommend-task.vue?vue&type=script&setup=true&lang=js"

import "./pc-recommend-task.vue?vue&type=style&index=0&id=b72e3068&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b72e3068"]])

export default __exports__